import React, {useMemo, useRef} from 'react';
import {isDesktop} from 'react-device-detect';
import YouTube from "react-youtube";
import {Dialog, DialogContent} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import "./youTubeDialog.css";

const useStyles = makeStyles(theme => ({
    paper: {
        "& .MuiDialogTitle-root": {
            backgroundColor: theme.palette.primary.main,
        },
        "& .MuiDialogContent-root": {
            padding: "0",
            margin: "0",
            overflow: "hidden",
        },
        "& .MuiPaper-root": {
            padding: "0",
            margin: "0",
            overflow: "hidden",
        },
    },
    landscape: {
        "& .MuiPaper-root": {
            maxWidth: isDesktop ? "560px" : "400px"
        },
    },
    portrait: {
        "& .MuiPaper-root": {
            maxWidth: "315px"
        },
    },
}));

const YouTubeDialog = props => {
    const { title, videoId, onClose, onWatched, thresholdPercent = 90,
        mode = isDesktop ? "landscape" : "portrait"} = props;
    const classes = useStyles();
    const player = useRef(null);
    const triggered = useRef(false);

    const dimensions = useMemo(() => {
        return "portrait" === mode ?
            {
                width: 315,
                height: 560,
            } :
            {
                width: 560,
                height: 315,
            }
    }, [mode]);

    const options = useMemo(() => {
        return {
            width: dimensions.width,
            height: dimensions.height,
            playerVars: {
                rel: 0,
            },
            host: "https://www.youtube-nocookie.com",
        }
    }, [dimensions]);

    const exit = () => {
        checkPercentWatched(player.current);
        onClose();
    };

    const checkPercentWatched = (video) => {
        if (video) {
            const total = video.getDuration();
            const current = video.getCurrentTime();
            const percent = total > 0
                ? Math.min((current / total) * 100, 100)
                : 0;

            console.log("percent watched: " + percent);

            if (percent >= thresholdPercent) {
                if (onWatched && !triggered.current) {
                    triggered.current = true;
                    onWatched(percent);
                }

            } else if (!player.current) {
                player.current = video;
            }
        }
    };

    return <Dialog
        open={true}
        className={[classes.paper, mode === "landscape" ? classes.landscape : classes.portrait]}
        aria-labelledby="youtube-dialog"
    >
        <ClosableDialogTitle onClose={exit}>
            {title}
        </ClosableDialogTitle>
        <DialogContent>
            <YouTube
                className="video"
                videoId={videoId}
                opts={options}
                onReady={(e) => player.current = e.target}
                onStateChange={(e) => checkPercentWatched(e.target)}
            />
        </DialogContent>
    </Dialog>
}

export default YouTubeDialog;
